import React, { useEffect, useState } from "react";
import axios from "axios";

export default function Faq() {
  const [faqContent, setFaqContent] = useState("");
  const [webFont, setWebFont] = useState("");
  const [themeColor, setThemeColor] = useState("");
  const [themeIconColor, setThemeIconColor] = useState("");

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setWebFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);
    }
  }, []);

  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  useEffect(() => {
    const fetchFaq = async () => {
      try {
        const formData = new FormData();
        formData.append("admin_auto_id", sessionStorage.getItem("admin_auto_id"));

        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/Show-Faq`,
          formData
        );

        if (response.data.status === 1 && response.data.allfaqs.length > 0) {
          setFaqContent(response.data.allfaqs[0].faq);
        }
      } catch (error) {
        console.error("Error fetching faq:", error);
      }
    };

    fetchFaq();
  }, []);

  return (
    <div className={`flex flex-col w-full px-4 sm:px-6 lg:px-8 ${webFont}`}>
      <h2 className="mb-4 text-xl font-bold text-center text-black">Faq</h2>

      {faqContent && (
        <div className="w-full max-w-6xl p-4 mx-auto rounded-lg shadow-sm bg-gray-50 sm:p-6">
          {/*  IMPORTANT: preserve formatting from API */}
          <div className="text-sm leading-relaxed text-left text-gray-700 whitespace-pre-line sm:text-base">
            {faqContent}
          </div>
        </div>
      )}
    </div>
  );
}
